<template>
  <div class="room">
    <Page :search-bar="searchBar" :table="table" :pagination="pagination" @selectedRows="selectedRows">
      <div slot="operate-bar" class="operate-bar">
        <el-button type="primary" @click="handleAddRoom">新增</el-button>
        <!-- <el-button type="danger" @click="handleDeleteList">批量删除</el-button> -->
      </div>
      <template slot="table-operate" slot-scope="{scope}">
        <el-button type="text" style="margin-right: 20px;margin-left:20px;"  @click="edit(scope)">编辑</el-button>
        <el-button type="text" @click="deleteItem([scope.id])" style="color: #f33458; cursor: pointIder;margin-right: 20px ">删除</el-button>
      </template>
      <Dialogs :title="dialogTitle" :is-show-dialog="isShowDialog" width="26%" @handleClick="closeDialog">
        <div slot="content">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
            <el-form-item label="房间名称" prop="roomName">
              <el-input v-model.trim="ruleForm.roomName"></el-input>
            </el-form-item>
            <el-form-item label="视频展示" prop="videoPlayState">
              <el-select v-model="ruleForm.videoPlayState" placeholder="请选择是否展示视频">
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="点位" prop="pointId">
              <el-select v-model="ruleForm.pointId" clearable placeholder="请选择点位" @clear="clearPoint" @change="changePoint">
                <el-option v-for="item in pointIdList" :key="item.id" :label="item.pointName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </Dialogs>
    </Page>
  </div>
</template>
<script>
import Page from '@/components/Page.vue'
import Dialogs from '@/components/page/Dialogs.vue'
import { addRoom, getPointList, getRoomList, batchDelete, updateRoom } from '@/api/dataDictionary'
export default {
  components: {
    Page,
    Dialogs
  },
  data () {
    return {
      searchBar: {
        list: [{
          type: 'input',
          prop: 'roomName',
          label: '房间名称',
          placeholder: '请输入'
        }, {
          type: 'btn',
          text: '搜索',
          btnType: 'primary',
          callback: this.searchBarform
        }, {
          type: 'btn',
          text: '重置',
          btnType: 'primary',
          isReset: true,
          callback: this.resetList
        }]
      },
      params: {
        roomName: ''
      },
      table: {
        selection: true, // 是否开启选择框
        tableInfo: [{
          key: 'num',
          name: '序号',
          minWidth: 30
        }, {
          key: 'roomName',
          name: '房间名称',
          minWidth: 80
        }, {
          key: 'videoPlayStateName',
          name: '视频展示',
          minWidth: 60
        }, {
          key: 'pointName',
          name: '点位',
          minWidth: 60
        }],
        tableData: [],
        deleteList: () => {
          this.handleDeleteList()
        }
      },
      pagination: {
        total: 0,
        currentPage: 1,
        size: 10,
        currentChange: (page) => {
          this.handleCurrentChange(page)
        },
        sizeChange: (size) => {
          this.handleSizeChange(size)
        }
      },
      isShowDialog: false,
      ruleForm: {
        roomName: '',
        videoPlayState: 0,
        pointId: ''
      },
      rules: {
        roomName: [
          { required: true, message: '请输入房间名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        pointId: [{ required: false }]
      },
      pointIdList: [],
      selectList: [],
      deleteIds: [],
      dialogTitle: '',
      ms: null
    }
  },
  mounted () {
    this.getPointList()
    this.getRoomList()
  },
  methods: {
    async getPointList () {
      const {data} = await getPointList()
      this.pointIdList = data
    },
    async addRoom () {
      await addRoom({...this.ruleForm})
      this.getRoomList()
      this.$message.success('新增成功！')
      this.resetForm()
    },
    async getRoomList () {
      const {data} = await getRoomList({
        size: this.pagination.size,
        current: this.pagination.currentPage,
        roomName: this.params.roomName
      })
      this.pagination.total = data.total
      this.table.tableData = data.records
      this.table.tableData.forEach((item, idx) => {
        item.num = (this.pagination.currentPage - 1) * this.pagination.size + idx + 1
        item.videoPlayStateName = item.videoPlayState ? '是' : '否'
      })
    },
    async updateRoom () {
      const {id, roomName, videoPlayState, pointId} = this.ruleForm
      await updateRoom({
        id, roomName, videoPlayState, pointId
      })
      this.getRoomList()
      this.$message.success('保存成功！')
      this.resetForm()
    },
    async batchDelete () {
      await batchDelete(this.deleteIds)
      if (this.table.tableData.length === this.deleteIds.length && this.pagination.currentPage > 1) this.pagination.currentPage -= 1
      this.getRoomList()
    },
    searchBarform (params) {
      this.ms && this.ms.close()
      this.params = {...this.params, ...params}
      const {roomName} = this.params
      if (roomName && roomName.length > 20) {
        this.ms = this.$message({
          type: 'warning',
          message: '搜索的长度不能超过20字'
        })
        return
      }
      this.pagination.currentPage = 1
      this.getRoomList()
    },
    resetList () {
      this.pagination.currentPage = 1
      this.params = {
        roomName: ''
      }
      this.getRoomList()
    },
    handleSizeChange (val) {
      this.pagination.size = val
      this.$nextTick(() => {
        this.getRoomList()
      })
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.$nextTick(() => {
        this.getRoomList()
      })
    },
    handleAddRoom () {
      this.isShowDialog = true
      this.dialogTitle = '新增房间'
      window.addEventListener('keyup', this.handleKeyUp)
    },
    handleDeleteList () {
      this.deleteIds = []
      this.selectList.forEach(item => {
        this.deleteIds.push(item.id)
      })
      this.confirmDelete()
    },
    edit (val) {
      this.isShowDialog = true
      this.dialogTitle = '修改房间'
      window.addEventListener('keyup', this.handleKeyUp)
      this.ruleForm = JSON.parse(JSON.stringify(val))
      if (val.pointName) {
        this.ruleForm.pointId = this.pointIdList.find(item => item.pointName === val.pointName).id
      }
    },
    selectedRows (val) {
      this.selectList = val
    },
    deleteItem (val) {
      this.deleteIds = val
      this.confirmDelete()
    },
    changePoint (val) {
      this.$set(this.ruleForm, 'pointId', val)
      this.$forceUpdate()
    },
    clearPoint () {
      this.$set(this.ruleForm, 'pointId', null)
      this.$forceUpdate()
    },
    confirmDelete () {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      })
        .then(() => {
          this.batchDelete()
        })
    },
    closeDialog (val) {
      if (val) {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            this.dialogTitle === '新增房间' ? this.addRoom() : this.updateRoom()
          }
        })
      } else {
        this.resetForm()
      }
    },
    resetForm () {
      this.isShowDialog = false
      this.ruleForm = {
        roomName: '',
        videoPlayState: 0,
        pointId: ''
      }
      window.removeEventListener('keyup', this.handleKeyUp)
    },
    handleKeyUp (event) {
      if (event.key === 'Enter') {
        this.closeDialog(true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-table__body-wrapper {
  height: calc(100% - 32px);
  overflow-y: auto;
}
.room {
  width: 100%;
  height: 100%;
}
</style>